<template>
  <div class="con-main">
    <div>Test</div>
    <div class="tab-container">
      <div class="tab-area">
        <div v-for="(t, index) in tabItems" :key="t" :class="[ 'tab', { active: t.IsActive == 1 } ]" @click="tabChanged(index)">
          {{ t.TabName }}
        </div>
      </div>
      <div class="tab-content">

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    tabItems: { type: Array, default: [ 
      { 'TabName': 'Tab 1', 'IsActive': 1 },
      { 'TabName': 'Tab 2', 'IsActive': 0 },
      { 'TabName': 'Tab 3', 'IsActive': 0 },
    ] }
  },
  methods: {
    tabChanged: function(index) {
      this.tabItems.forEach((t) => {
        t.IsActive = 0;
      });

      this.tabItems[index].IsActive = 1;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.con-main {
  position: relative;
  height: 100%;
  width: 100%;
  padding: 10px 40px;
  display: flex;
  flex-direction: column;
}

.tab-container {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.tab-container .tab-area {
  height: 30px;
  width: 100%;
  // background-color: blue;
  padding: 0 10px;
  display: flex;
}

.tab-area .tab {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100px;
  width: 100%;
  border-color: black;
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  user-select: none;
  cursor: pointer;
}

.tab-container .tab-content {
  width: 100%;
  flex-grow: 1;
  border: 1px solid black;
  border-radius: 5px;
}

.active {
  transform: scale(1.1);
  z-index: 5;
  background-color: white;
}
</style>